
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Puneairportcabservice() {



    const cardData =
    {
        keyword: 'Pune Airport Cab Service',
        heading: 'S9 Travels: Pune Airport Cab Service',
        headingDescription: 'S9 Travels offers reliable, on-time Pune Airport cab services for business and leisure travelers alike. Whether you need a fast pickup from Pune Airport or a stress-free drop-off, our professional chauffeurs and clean, air-conditioned cabs ensure a smooth and comfortable ride.',

        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a historic fort built in 1732, once the seat of the Peshwas of the Maratha Empire. It is famous for its majestic gates, intricate architecture, and rich history."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Aga Khan Palace is a historic landmark where Mahatma Gandhi and his wife were imprisoned during the Quit India Movement. It now serves as a museum showcasing artifacts from India's freedom struggle."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located on a hilltop, Sinhagad Fort is known for its scenic beauty and historical significance. It was the site of an important battle in Maratha history and is a popular trekking destination."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "One of Pune’s most famous temples, this temple is dedicated to Lord Ganesha. The idol is adorned with gold and attracts thousands of devotees and tourists every year."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum showcases a vast collection of artifacts, including sculptures, paintings, and musical instruments, offering a glimpse into India’s cultural heritage."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An ancient rock-cut temple dedicated to Lord Shiva, this 8th-century structure is an important archaeological site in Pune, featuring intricate carvings and a serene atmosphere."
    },
    {
      "title": "Vetal Tekdi",
      "description": "Vetal Tekdi is one of Pune’s highest points, offering panoramic views of the city. It is a favorite spot for trekkers, nature lovers, and fitness enthusiasts."
    },
    {
      "title": "Pashan Lake",
      "description": "A beautiful artificial lake, Pashan Lake is a great place for birdwatching and relaxing walks. It provides a peaceful escape from the city's hustle and bustle."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a renowned spiritual retreat offering meditation programs and wellness therapies."
    },
    {
      "title": "FC Road and JM Road",
      "description": "Fergusson College Road (FC Road) and Jangali Maharaj Road (JM Road) are popular for shopping, street food, and vibrant nightlife, attracting youngsters and tourists alike."
    }
],

"services": [
  {
    "name": "Pune Airport Cab Service",
    "description": "Book trusted Pune Airport cab services with S9 Travels for timely pickups and smooth drop-offs. Perfect for business and leisure travelers looking for comfort, safety, and reliability."
  },
  {
    "name": "Book Pune Airport Taxi Online",
    "description": "Quickly reserve your Pune Airport taxi through our easy online booking system. Choose from hatchbacks, sedans, and SUVs for a secure, on-time airport ride."
  },
  {
    "name": "Affordable Cab to Pune Airport",
    "description": "Looking for budget-friendly airport transport? Our Pune Airport cab service offers low-cost yet quality rides with professional drivers and clean, comfortable vehicles."
  },
  {
    "name": "Private Airport Taxi in Pune",
    "description": "Enjoy a peaceful ride with our private Pune Airport taxi service. Ideal for solo travelers, couples, or executives seeking privacy and convenience."
  },
  {
    "name": "Comfortable Ride from Pune City to Airport",
    "description": "Travel stress-free with our comfortable Pune to Airport cab service. Enjoy cushioned seating, air conditioning, and courteous drivers for a relaxing transfer."
  },
  {
    "name": "Luxury Cab for Pune Airport Transfers",
    "description": "Make your airport transfer special with our luxury cab service. Premium interiors and top-tier comfort make this an excellent choice for VIPs or business travelers."
  },
  {
    "name": "Group Travel Cab for Pune Airport",
    "description": "Traveling in a group? Our spacious airport taxis accommodate families and groups with ample luggage space—perfect for vacation or corporate travel."
  },
  {
    "name": "Pune Airport Pickup and Drop Taxi",
    "description": "Get reliable pickup and drop services to and from Pune Airport. We track flight timings to ensure prompt arrivals and departures—day or night."
  },
  {
    "name": "24x7 Pune Airport Taxi Booking",
    "description": "Book Pune Airport taxis any time with our 24/7 support and online booking system. Whether it’s late night or early morning, we’re always ready to serve."
  }
],
  "tableData": [
    ["Pune Airport Cab Service", "Book Pune Airport Taxi"],
    ["Affordable Pune Airport Cab", "Private Taxi for Pune Airport"],
    ["Comfortable Taxi Ride to Pune Airport", "Luxury Cab from Pune City to Airport"],
    ["Group Travel to Pune Airport", "Pune Airport Taxi Booking Online"],
    ["Quick and Reliable Taxi Service to Pune Airport", "Affordable Pune Airport Cab"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of reaching your flight on time or getting to your destination from Pune Airport promptly. We ensure timely pickups and smooth rides to and from the airport. Our drivers are always punctual, ensuring you reach your destination or the airport without delay."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is the perfect vehicle for your ride to or from Pune Airport. With comfortable seating, air conditioning, and plenty of space for luggage, you'll enjoy a relaxing and stress-free journey. Whether you're traveling alone or with family, our vehicles provide the comfort you need for the journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes to and from Pune Airport. They are courteous, professional, and focused on ensuring a safe, comfortable, and timely journey. With their knowledge and expertise, you can relax and enjoy the ride."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune Airport ride. You’ll receive a detailed breakdown of all costs upfront, with no hidden charges, allowing you to plan your travel without surprises."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our Toyota Innova vehicles are equipped with modern safety features, including airbags, seat belts, and GPS tracking, ensuring a secure and comfortable ride throughout your journey to or from Pune Airport."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "No matter the time of day or night, S9 Travels is available 24/7 for your airport transport needs. Whether you're catching an early flight or arriving late at night, we ensure your ride is ready, and our customer service team is available around the clock to assist you."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune Airport cab is quick and easy with S9 Travels. You can book online via our website or mobile app, or contact our customer service team for personalized assistance in securing your ride."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your airport ride. Whether you need additional services such as a stop along the way or specific preferences, we tailor the trip to meet your needs, ensuring you have a smooth and convenient journey."
  }
]






    }



    const faqData = [
        [
          {
            question: 'How can I book a cab for Pune Airport with S9 Travels?',
            answer: 'Booking a cab for Pune Airport is easy! You can book your ride online through our website or mobile app, or contact our customer service team for assistance with your booking.'
          },
          {
            question: 'What types of cabs are available for Pune Airport travel?',
            answer: 'We offer a range of vehicles, including the spacious Toyota Innova, ideal for families, groups, or passengers with extra luggage. Choose the vehicle that suits your needs for a comfortable journey to or from Pune Airport.'
          },
          {
            question: 'Are the drivers experienced for Pune Airport travel?',
            answer: 'Yes, our drivers are experienced and familiar with the routes to and from Pune Airport, ensuring a smooth, safe, and timely journey.'
          },
          {
            question: 'What payment options are available for booking a cab to or from Pune Airport?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and secure online payments through our mobile app, making it convenient and easy to pay for your ride.'
          },
          {
            question: 'Can I book a round trip to Pune Airport?',
            answer: 'Yes, you can book a round trip. Just provide us with your return details, and we’ll ensure your ride back from Pune Airport is smooth and timely.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time at Pune Airport?',
            answer: 'Any extra charges for detours or waiting time at the airport will be clearly communicated to you in advance, ensuring full transparency in pricing.'
          },
          {
            question: 'Can I make additional stops along the way to or from Pune Airport?',
            answer: 'Yes, you can make additional stops. Please inform us during the booking process, and we’ll accommodate your requests for detours or stops along the way.'
          },
          {
            question: 'What is the luggage allowance for a cab to Pune Airport?',
            answer: 'The Toyota Innova offers plenty of space for standard luggage. If you have more luggage or special requirements, please let us know when booking, and we will make the necessary arrangements.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Pune Airport?',
            answer: 'Yes, we offer corporate travel services to and from Pune Airport. We ensure a professional and comfortable journey for business travelers with timely pickups and drop-offs.'
          },
          {
            question: 'Why should I choose S9 Travels for my Pune Airport cab booking?',
            answer: 'S9 Travels provides a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a hassle-free and enjoyable journey to or from Pune Airport.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Neeraj Agarwal',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab for Pune Airport with S9 Travels, and the service was excellent. The driver was punctual, the vehicle was clean and spacious, and the ride was comfortable. Highly recommended for airport transfers!”'
        },
        {
          name: 'Mrs. Komal Mehra',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels made my trip to Pune Airport seamless. The driver was professional, and the vehicle was comfortable and well-maintained. I will definitely use their service again for future airport travel.”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
      

    
      
      
      
     

//       const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Pune Airport Cab Service",
//   "image": "/images/keyword/pune-airport-cab.jpg",
//   "description": "Book Pune Airport cab service with S9 Travels. Affordable one-way and round-trip cabs with AC Hatchback, Sedan, SUV & Innova. Enjoy 24/7 airport transfers, professional drivers, on-time pickups, and seamless travel to or from Pune Airport.",
//   "brand": { "@type": "Brand", "name": "S9 Travels" },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.9",
//     "ratingCount": "8123"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "799",
//     "availability": "https://schema.org/InStock",
//     "url": "https://s9travels.com/pune-airport-cab-service"
//   }
// };
      

const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune Airport Cab Service",
        "image": "https://www.s9travels.com/images/keyword/94.jpg",
        "description": "Book a reliable and affordable Pune Airport cab service with S9 Travels. Enjoy timely pickups and drop-offs with experienced drivers, clean vehicles, and flexible booking options. Perfect for solo travelers, families, or groups looking for hassle-free airport transfers.",
        "brand": {
          "@type": "Brand",
          "name": "S9 Travels"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "6892"
        },
        "offers": {
          "@type": "Offer",
          "priceCurrency": "INR",
          "price": "899",
          "availability": "https://schema.org/InStock",
          "url": "https://www.s9travels.com/Pune-Airport-Cab-Service"
        }
      };
      
    return (
        <div>
           
      <Helmet>
  <title>Pune Airport Cab Service | S9 Travels</title>
  <meta 
    name="description" 
    content="Book reliable Pune Airport cab service with S9 Travels. 24x7 airport pickup & drop, on-time service, professional drivers, and clean AC cabs. Choose private or group airport transfers now." 
  />
  <meta 
    name="keywords" 
    content="Pune Airport Cab, Pune Airport Taxi Service, 24x7 Airport Cab Pune, Pune Airport Pickup and Drop, Cab to Pune Airport, Taxi from Pune Airport, Airport Transfers Pune, S9 Travels Airport Cabs" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


{/* <Helmet>
  <title>Pune Airport Cab Service | 24/7 Taxi Booking from ₹799 | S9 Travels</title>

  <meta
    name="description"
    content="Book Pune Airport cab service online with S9 Travels. One-way and round-trip cabs with AC Hatchback, Sedan, SUV & Innova. Affordable fares, timely pickups, professional drivers, and 24/7 airport transfers for a safe and smooth journey."
  />

  <meta
    name="keywords"
    content="Pune Airport Cab Service, Pune Airport Taxi Booking, One Way Cab Pune Airport, Round Trip Cab Pune Airport, Sedan Cab Pune Airport, SUV Taxi Pune Airport, Pune Airport to City Cab, Airport Drop Service Pune, Affordable Pune Airport Taxi, S9 Travels Pune Airport"
  />

  <link rel="canonical" href="https://s9travels.com/pune-airport-cab-service" />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> 
// by this showing on 7:1
*/}

      


      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/94.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Puneairportcabservice;